/**
 * Volunteer sign-up (inc/volunteer.php).
 *
 * Role cards (.role-card with a .role-title) become toggle buttons; the form is built inside .vol-form:
 * a line showing the chosen roles, name, phone, a hidden honeypot, the consent note and the button.
 * It posts to the REST endpoint and swaps in a thank-you message. Nothing runs without .vol-form.
 *
 * @package Sitamaa_Sahayata_Foundation
 */

( function () {
	'use strict';

	var cfg = window.ssfVolunteer || {};
	var t = window.ssfText || { f: String };

	function esc( s ) {
		var d = document.createElement( 'div' );
		d.textContent = s;
		return d.innerHTML;
	}

	// Wording kept in Elementor: paragraphs with the classes form-consent, form-button, form-note and
	// form-thanks inside the form box. Read once (the box is rebuilt after sending); the defaults in
	// window.ssfText stand in for any paragraph that was removed.
	function copyOf( holder, d ) {
		if ( ! holder.ssfCopy ) {
			var get = function ( cls, html ) {
				var el = holder.querySelector( '.' + cls );
				return el ? ( html ? el.innerHTML : el.textContent ).trim() : '';
			};
			holder.ssfCopy = {
				consent: get( 'form-consent', true ) || esc( d.consent ) + ' <a href="' + esc( t.privacy ) + '">' + esc( t.privacy_link ) + '</a>.',
				button: get( 'form-button' ) || d.button,
				note: get( 'form-note' ) || d.note,
				thanks: get( 'form-thanks' ) || d.thanks
			};
		}
		return holder.ssfCopy;
	}

	function setup( holder, again ) {
		var section = holder.closest( 'section' ) || document;
		var cards = Array.prototype.slice.call( section.querySelectorAll( '.role-card' ) );
		holder.ssfCards = cards;
		var copy = copyOf( holder, { consent: t.vol_consent, button: t.vol_button, note: t.vol_note, thanks: t.f( t.vol_done, t.phone ) } );

		holder.innerHTML =
			'<form class="vol-f" novalidate>' +
			'<p class="vol-picked" aria-live="polite">' + esc( t.vol_prompt ) + '</p>' +
			'<div class="vol-field"><label for="vol-name">' + esc( t.name_label ) + '</label><input id="vol-name" name="name" autocomplete="name" placeholder="' + esc( t.name_placeholder ) + '" maxlength="80"><p class="vol-err" id="vol-name-err"></p></div>' +
			'<div class="vol-field"><label for="vol-phone">' + esc( t.phone_label ) + '</label><input id="vol-phone" name="phone" inputmode="numeric" autocomplete="tel" placeholder="' + esc( t.phone_placeholder ) + '" maxlength="16"><p class="vol-err" id="vol-phone-err"></p></div>' +
			'<div class="vol-hp" aria-hidden="true"><label for="vol-website">Website</label><input id="vol-website" name="website" tabindex="-1" autocomplete="off"></div>' +
			'<p class="vol-consent">' + copy.consent + '</p>' +
			'<button class="vol-btn" type="submit">' + esc( copy.button ) + '</button>' +
			'<p class="vol-note"><i aria-hidden="true"></i>' + esc( copy.note ) + '</p>' +
			'<p class="vol-fail" role="alert"></p>' +
			'</form>';

		var form = holder.querySelector( 'form' );
		var picked = form.querySelector( '.vol-picked' );

		function chosen() {
			return cards.filter( function ( c ) {
				return 'true' === c.getAttribute( 'aria-pressed' );
			} ).map( function ( c ) {
				return ( c.querySelector( '.role-title' ) || c ).textContent.trim();
			} );
		}

		function showPicked() {
			var list = chosen();
			picked.innerHTML = list.length ? t.f( esc( t.vol_picked ), '<b>' + esc( list.join( ', ' ) ) + '</b>' ) : esc( t.vol_prompt );
		}

		// Cards are bound once; a second setup (after "Add another volunteer") only rebuilds the form.
		section.ssfShowPicked = showPicked;
		cards.forEach( function ( c ) {
			if ( again ) {
				return;
			}
			c.setAttribute( 'role', 'button' );
			c.setAttribute( 'tabindex', '0' );
			c.setAttribute( 'aria-pressed', 'false' );
			function toggle() {
				c.setAttribute( 'aria-pressed', 'true' === c.getAttribute( 'aria-pressed' ) ? 'false' : 'true' );
				if ( section.ssfShowPicked ) {
					section.ssfShowPicked();
				}
			}
			c.addEventListener( 'click', toggle );
			c.addEventListener( 'keydown', function ( e ) {
				if ( 'Enter' === e.key || ' ' === e.key ) {
					e.preventDefault();
					toggle();
				}
			} );
		} );

		function fieldError( input, msg ) {
			var err = form.querySelector( '#' + input.id + '-err' );
			if ( msg ) {
				input.setAttribute( 'aria-invalid', 'true' );
				input.setAttribute( 'aria-describedby', err.id );
			} else {
				input.removeAttribute( 'aria-invalid' );
			}
			err.textContent = msg || '';
		}

		form.addEventListener( 'submit', function ( e ) {
			e.preventDefault();
			var name = form.elements.name;
			var phone = form.elements.phone;
			var digits = phone.value.replace( /\D/g, '' ).replace( /^91(?=\d{10}$)/, '' );
			var bad = null;
			fieldError( name, name.value.trim() ? '' : t.err_name );
			fieldError( phone, /^[6-9]\d{9}$/.test( digits ) ? '' : t.err_phone );
			if ( ! name.value.trim() ) {
				bad = name;
			} else if ( ! /^[6-9]\d{9}$/.test( digits ) ) {
				bad = phone;
			}
			if ( bad ) {
				bad.focus();
				return;
			}
			var btn = form.querySelector( '.vol-btn' );
			var fail = form.querySelector( '.vol-fail' );
			btn.disabled = true;
			btn.textContent = t.sending;
			fail.textContent = '';
			fetch( cfg.url, {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': cfg.nonce || '' },
				body: JSON.stringify( { name: name.value.trim(), phone: digits, roles: chosen(), website: form.elements.website.value } )
			} ).then( function ( r ) {
				return r.json().then( function ( data ) {
					return { ok: r.ok, data: data };
				} );
			} ).then( function ( res ) {
				if ( ! res.ok ) {
					throw new Error( ( res.data && res.data.message ) || t.err_send );
				}
				var list = chosen();
				// The sign-up is done: clear the chosen roles so the cards are ready for the next person.
				cards.forEach( function ( c ) {
					c.setAttribute( 'aria-pressed', 'false' );
				} );
				holder.innerHTML = '<div class="vol-done" role="status" tabindex="-1"><span class="vol-tick" aria-hidden="true"></span>' +
					'<p class="vol-done-h">' + esc( t.f( t.thanks, name.value.trim() ) ) + '</p>' +
					'<p class="vol-done-p">' + ( list.length ? esc( t.f( t.vol_noted, list.join( ', ' ) ) ) + ' ' : '' ) +
					esc( copy.thanks ) + '</p>' +
					'<button type="button" class="vol-again">' + esc( t.vol_again ) + '</button></div>';
				holder.querySelector( '.vol-again' ).addEventListener( 'click', function () {
					setup( holder, true );
					holder.querySelector( '#vol-name' ).focus();
				} );
				holder.querySelector( '.vol-done' ).focus();
			} ).catch( function ( err ) {
				btn.disabled = false;
				btn.textContent = copy.button;
				fail.textContent = err.message + ' ' + t.f( t.call_too, t.phone );
			} );
		} );
	}

	function init() {
		if ( document.body.classList.contains( 'elementor-editor-active' ) ) {
			return;
		}
		Array.prototype.forEach.call( document.querySelectorAll( '.vol-form' ), setup );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
